import React from "react";
import { Fragment } from "react";

export default function EmailHeader() {
  return (
    <Fragment>
      <div className="row customers">
        <div className="col-sm-5 ">
          <h2>Service Email Settings</h2>
        </div>
      </div>
    </Fragment>
  );
}
